export default function changePasswordForm(params) {
    this.popup('changePasswordPortalUser', {data: params});
    return true;
}
